import React from "react";
import { func } from "prop-types";

const BookingsLoadingError = ({ onClick }) => {
  return (
    <div className="w-100 d-flex flex-column justify-content-center align-items-center">
      <img src="/images/icons/timesheet-error.svg" className="mb-2" />
      <h2>Loading failed</h2>
      <b className="mt-2 text-center">
        There has been an error in loading your bookings.
      </b>
      <b className="text-center">Please click on the button below to retry.</b>
      <button
        className="btn btn-primary font-weight-bold mt-2"
        onClick={onClick}
      >
        Try again
      </button>
    </div>
  );
};

BookingsLoadingError.propTypes = {
  onClick: func,
};

export default BookingsLoadingError;
